// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AssessmentRouteImport } from './routes/assessment'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BlogsRouteImport } from './routes/blogs'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as DiagnosticsRouteImport } from './routes/diagnostics'
import { Route as DoctorsRouteImport } from './routes/doctors'
import { Route as EntRouteImport } from './routes/ent'
import { Route as GeneralSurgeryRouteImport } from './routes/general-surgery'
import { Route as GynecologyRouteImport } from './routes/gynecology'
import { Route as HealicPlusRouteImport } from './routes/healic-plus'
import { Route as LocationRouteImport } from './routes/location'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as OpdDoctorsRouteImport } from './routes/opd-doctors'
import { Route as OphthalmologistRouteImport } from './routes/ophthalmologist'
import { Route as OrthopaedicsRouteImport } from './routes/orthopaedics'
import { Route as PathLabRouteImport } from './routes/path-lab'
import { Route as PatientCareRouteImport } from './routes/patient-care'
import { Route as PharmacyRouteImport } from './routes/pharmacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ReturnAndExchangeRouteImport } from './routes/return-and-exchange'
import { Route as ReturnsExchangesRouteImport } from './routes/returns-exchanges'
import { Route as RunWithHealicRouteImport } from './routes/run-with-healic'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ShippingPolicyRouteImport } from './routes/shipping-policy'
import { Route as SurgeryDoctorsRouteImport } from './routes/surgery-doctors'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as UrologyRouteImport } from './routes/urology'
import { Route as CityTopicRouteImport } from './routes/$city.$topic'
import { Route as AestheticsIndexRouteImport } from './routes/aesthetics.index'
import { Route as AestheticsSlugRouteImport } from './routes/aesthetics.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CosmeticGynecologyIndexRouteImport } from './routes/cosmetic-gynecology.index'
import { Route as CosmeticGynecologySlugRouteImport } from './routes/cosmetic-gynecology.$slug'
import { Route as DoctorsIndexRouteImport } from './routes/doctors.index'
import { Route as DoctorsSlugRouteImport } from './routes/doctors.$slug'
import { Route as EntSurgeriesSlugRouteImport } from './routes/ent-surgeries.$slug'
import { Route as GeneralSurgeriesSlugRouteImport } from './routes/general-surgeries.$slug'
import { Route as GynecologySurgeriesSlugRouteImport } from './routes/gynecology-surgeries.$slug'
import { Route as LocationIndexRouteImport } from './routes/location.index'
import { Route as LocationAgraRouteImport } from './routes/location.agra'
import { Route as LocationHaridwarRouteImport } from './routes/location.haridwar'
import { Route as LocationIndirapuramGhaziabadRouteImport } from './routes/location.indirapuram-ghaziabad'
import { Route as LocationMuzaffarnagarRouteImport } from './routes/location.muzaffarnagar'
import { Route as LocationSohnaRoadGurugramRouteImport } from './routes/location.sohna-road-gurugram'
import { Route as LocationsIndexRouteImport } from './routes/locations.index'
import { Route as LocationsAgraRouteImport } from './routes/locations.agra'
import { Route as LocationsHaridwarRouteImport } from './routes/locations.haridwar'
import { Route as LocationsIndirapuramGhaziabadRouteImport } from './routes/locations.indirapuram-ghaziabad'
import { Route as LocationsMuzaffarnagarRouteImport } from './routes/locations.muzaffarnagar'
import { Route as LocationsSohnaRoadGurugramRouteImport } from './routes/locations.sohna-road-gurugram'
import { Route as OpdDoctorsSlugRouteImport } from './routes/opd-doctors.$slug'
import { Route as OphthalmologistSurgeriesSlugRouteImport } from './routes/ophthalmologist-surgeries.$slug'
import { Route as OrthopaedicsSurgeriesSlugRouteImport } from './routes/orthopaedics-surgeries.$slug'
import { Route as PatientCarePathLabRouteImport } from './routes/patient-care.path-lab'
import { Route as SpecialtiesIndexRouteImport } from './routes/specialties.index'
import { Route as SpecialtiesSlugRouteImport } from './routes/specialties.$slug'
import { Route as SurgeriesIndexRouteImport } from './routes/surgeries.index'
import { Route as SurgeriesSlugRouteImport } from './routes/surgeries.$slug'
import { Route as SurgeryDoctorsSlugRouteImport } from './routes/surgery-doctors.$slug'
import { Route as TreatmentsSlugRouteImport } from './routes/treatments.$slug'
import { Route as UrologySurgeriesSlugRouteImport } from './routes/urology-surgeries.$slug'
import { Route as BlogVideosSlugRouteImport } from './routes/blog.videos.$slug'
import { Route as SurgeriesSlugLocationRouteImport } from './routes/surgeries.$slug.$location'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AssessmentRoute = AssessmentRouteImport.update({
            id: '/assessment',path: '/assessment',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BlogsRoute = BlogsRouteImport.update({
            id: '/blogs',path: '/blogs',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const DiagnosticsRoute = DiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => rootRouteImport
          })
const DoctorsRoute = DoctorsRouteImport.update({
            id: '/doctors',path: '/doctors',getParentRoute: () => rootRouteImport
          })
const EntRoute = EntRouteImport.update({
            id: '/ent',path: '/ent',getParentRoute: () => rootRouteImport
          })
const GeneralSurgeryRoute = GeneralSurgeryRouteImport.update({
            id: '/general-surgery',path: '/general-surgery',getParentRoute: () => rootRouteImport
          })
const GynecologyRoute = GynecologyRouteImport.update({
            id: '/gynecology',path: '/gynecology',getParentRoute: () => rootRouteImport
          })
const HealicPlusRoute = HealicPlusRouteImport.update({
            id: '/healic-plus',path: '/healic-plus',getParentRoute: () => rootRouteImport
          })
const LocationRoute = LocationRouteImport.update({
            id: '/location',path: '/location',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const OpdDoctorsRoute = OpdDoctorsRouteImport.update({
            id: '/opd-doctors',path: '/opd-doctors',getParentRoute: () => rootRouteImport
          })
const OphthalmologistRoute = OphthalmologistRouteImport.update({
            id: '/ophthalmologist',path: '/ophthalmologist',getParentRoute: () => rootRouteImport
          })
const OrthopaedicsRoute = OrthopaedicsRouteImport.update({
            id: '/orthopaedics',path: '/orthopaedics',getParentRoute: () => rootRouteImport
          })
const PathLabRoute = PathLabRouteImport.update({
            id: '/path-lab',path: '/path-lab',getParentRoute: () => rootRouteImport
          })
const PatientCareRoute = PatientCareRouteImport.update({
            id: '/patient-care',path: '/patient-care',getParentRoute: () => rootRouteImport
          })
const PharmacyRoute = PharmacyRouteImport.update({
            id: '/pharmacy',path: '/pharmacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProductsRoute = ProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => rootRouteImport
          })
const ReturnAndExchangeRoute = ReturnAndExchangeRouteImport.update({
            id: '/return-and-exchange',path: '/return-and-exchange',getParentRoute: () => rootRouteImport
          })
const ReturnsExchangesRoute = ReturnsExchangesRouteImport.update({
            id: '/returns-exchanges',path: '/returns-exchanges',getParentRoute: () => rootRouteImport
          })
const RunWithHealicRoute = RunWithHealicRouteImport.update({
            id: '/run-with-healic',path: '/run-with-healic',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ShippingPolicyRoute = ShippingPolicyRouteImport.update({
            id: '/shipping-policy',path: '/shipping-policy',getParentRoute: () => rootRouteImport
          })
const SurgeryDoctorsRoute = SurgeryDoctorsRouteImport.update({
            id: '/surgery-doctors',path: '/surgery-doctors',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const UrologyRoute = UrologyRouteImport.update({
            id: '/urology',path: '/urology',getParentRoute: () => rootRouteImport
          })
const CityTopicRoute = CityTopicRouteImport.update({
            id: '/$city/$topic',path: '/$city/$topic',getParentRoute: () => rootRouteImport
          })
const AestheticsIndexRoute = AestheticsIndexRouteImport.update({
            id: '/aesthetics/',path: '/aesthetics/',getParentRoute: () => rootRouteImport
          })
const AestheticsSlugRoute = AestheticsSlugRouteImport.update({
            id: '/aesthetics/$slug',path: '/aesthetics/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CosmeticGynecologyIndexRoute = CosmeticGynecologyIndexRouteImport.update({
            id: '/cosmetic-gynecology/',path: '/cosmetic-gynecology/',getParentRoute: () => rootRouteImport
          })
const CosmeticGynecologySlugRoute = CosmeticGynecologySlugRouteImport.update({
            id: '/cosmetic-gynecology/$slug',path: '/cosmetic-gynecology/$slug',getParentRoute: () => rootRouteImport
          })
const DoctorsIndexRoute = DoctorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DoctorsRoute
          })
const DoctorsSlugRoute = DoctorsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DoctorsRoute
          })
const EntSurgeriesSlugRoute = EntSurgeriesSlugRouteImport.update({
            id: '/ent-surgeries/$slug',path: '/ent-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const GeneralSurgeriesSlugRoute = GeneralSurgeriesSlugRouteImport.update({
            id: '/general-surgeries/$slug',path: '/general-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const GynecologySurgeriesSlugRoute = GynecologySurgeriesSlugRouteImport.update({
            id: '/gynecology-surgeries/$slug',path: '/gynecology-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const LocationIndexRoute = LocationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocationRoute
          })
const LocationAgraRoute = LocationAgraRouteImport.update({
            id: '/agra',path: '/agra',getParentRoute: () => LocationRoute
          })
const LocationHaridwarRoute = LocationHaridwarRouteImport.update({
            id: '/haridwar',path: '/haridwar',getParentRoute: () => LocationRoute
          })
const LocationIndirapuramGhaziabadRoute = LocationIndirapuramGhaziabadRouteImport.update({
            id: '/indirapuram-ghaziabad',path: '/indirapuram-ghaziabad',getParentRoute: () => LocationRoute
          })
const LocationMuzaffarnagarRoute = LocationMuzaffarnagarRouteImport.update({
            id: '/muzaffarnagar',path: '/muzaffarnagar',getParentRoute: () => LocationRoute
          })
const LocationSohnaRoadGurugramRoute = LocationSohnaRoadGurugramRouteImport.update({
            id: '/sohna-road-gurugram',path: '/sohna-road-gurugram',getParentRoute: () => LocationRoute
          })
const LocationsIndexRoute = LocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => rootRouteImport
          })
const LocationsAgraRoute = LocationsAgraRouteImport.update({
            id: '/locations/agra',path: '/locations/agra',getParentRoute: () => rootRouteImport
          })
const LocationsHaridwarRoute = LocationsHaridwarRouteImport.update({
            id: '/locations/haridwar',path: '/locations/haridwar',getParentRoute: () => rootRouteImport
          })
const LocationsIndirapuramGhaziabadRoute = LocationsIndirapuramGhaziabadRouteImport.update({
            id: '/locations/indirapuram-ghaziabad',path: '/locations/indirapuram-ghaziabad',getParentRoute: () => rootRouteImport
          })
const LocationsMuzaffarnagarRoute = LocationsMuzaffarnagarRouteImport.update({
            id: '/locations/muzaffarnagar',path: '/locations/muzaffarnagar',getParentRoute: () => rootRouteImport
          })
const LocationsSohnaRoadGurugramRoute = LocationsSohnaRoadGurugramRouteImport.update({
            id: '/locations/sohna-road-gurugram',path: '/locations/sohna-road-gurugram',getParentRoute: () => rootRouteImport
          })
const OpdDoctorsSlugRoute = OpdDoctorsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => OpdDoctorsRoute
          })
const OphthalmologistSurgeriesSlugRoute = OphthalmologistSurgeriesSlugRouteImport.update({
            id: '/ophthalmologist-surgeries/$slug',path: '/ophthalmologist-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const OrthopaedicsSurgeriesSlugRoute = OrthopaedicsSurgeriesSlugRouteImport.update({
            id: '/orthopaedics-surgeries/$slug',path: '/orthopaedics-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const PatientCarePathLabRoute = PatientCarePathLabRouteImport.update({
            id: '/path-lab',path: '/path-lab',getParentRoute: () => PatientCareRoute
          })
const SpecialtiesIndexRoute = SpecialtiesIndexRouteImport.update({
            id: '/specialties/',path: '/specialties/',getParentRoute: () => rootRouteImport
          })
const SpecialtiesSlugRoute = SpecialtiesSlugRouteImport.update({
            id: '/specialties/$slug',path: '/specialties/$slug',getParentRoute: () => rootRouteImport
          })
const SurgeriesIndexRoute = SurgeriesIndexRouteImport.update({
            id: '/surgeries/',path: '/surgeries/',getParentRoute: () => rootRouteImport
          })
const SurgeriesSlugRoute = SurgeriesSlugRouteImport.update({
            id: '/surgeries/$slug',path: '/surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const SurgeryDoctorsSlugRoute = SurgeryDoctorsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SurgeryDoctorsRoute
          })
const TreatmentsSlugRoute = TreatmentsSlugRouteImport.update({
            id: '/treatments/$slug',path: '/treatments/$slug',getParentRoute: () => rootRouteImport
          })
const UrologySurgeriesSlugRoute = UrologySurgeriesSlugRouteImport.update({
            id: '/urology-surgeries/$slug',path: '/urology-surgeries/$slug',getParentRoute: () => rootRouteImport
          })
const BlogVideosSlugRoute = BlogVideosSlugRouteImport.update({
            id: '/videos/$slug',path: '/videos/$slug',getParentRoute: () => BlogRoute
          })
const SurgeriesSlugLocationRoute = SurgeriesSlugLocationRouteImport.update({
            id: '/$location',path: '/$location',getParentRoute: () => SurgeriesSlugRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogVideosSlugRoute: BlogVideosSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const DoctorsRouteChildren = {
  DoctorsSlugRoute: DoctorsSlugRoute,DoctorsIndexRoute: DoctorsIndexRoute
}

const DoctorsRouteWithChildren = DoctorsRoute._addFileChildren(DoctorsRouteChildren)




const LocationRouteChildren = {
  LocationAgraRoute: LocationAgraRoute,LocationHaridwarRoute: LocationHaridwarRoute,LocationIndirapuramGhaziabadRoute: LocationIndirapuramGhaziabadRoute,LocationMuzaffarnagarRoute: LocationMuzaffarnagarRoute,LocationSohnaRoadGurugramRoute: LocationSohnaRoadGurugramRoute,LocationIndexRoute: LocationIndexRoute
}

const LocationRouteWithChildren = LocationRoute._addFileChildren(LocationRouteChildren)




const OpdDoctorsRouteChildren = {
  OpdDoctorsSlugRoute: OpdDoctorsSlugRoute
}

const OpdDoctorsRouteWithChildren = OpdDoctorsRoute._addFileChildren(OpdDoctorsRouteChildren)




const PatientCareRouteChildren = {
  PatientCarePathLabRoute: PatientCarePathLabRoute
}

const PatientCareRouteWithChildren = PatientCareRoute._addFileChildren(PatientCareRouteChildren)




const SurgeryDoctorsRouteChildren = {
  SurgeryDoctorsSlugRoute: SurgeryDoctorsSlugRoute
}

const SurgeryDoctorsRouteWithChildren = SurgeryDoctorsRoute._addFileChildren(SurgeryDoctorsRouteChildren)




const SurgeriesSlugRouteChildren = {
  SurgeriesSlugLocationRoute: SurgeriesSlugLocationRoute
}

const SurgeriesSlugRouteWithChildren = SurgeriesSlugRoute._addFileChildren(SurgeriesSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AboutUsRoute: AboutUsRoute,AccountRoute: AccountRoute,AdminRoute: AdminRoute,AssessmentRoute: AssessmentRoute,BlogRoute: BlogRouteWithChildren,BlogsRoute: BlogsRoute,CareersRoute: CareersRoute,ContactRoute: ContactRoute,ContactUsRoute: ContactUsRoute,DiagnosticsRoute: DiagnosticsRoute,DoctorsRoute: DoctorsRouteWithChildren,EntRoute: EntRoute,GeneralSurgeryRoute: GeneralSurgeryRoute,GynecologyRoute: GynecologyRoute,HealicPlusRoute: HealicPlusRoute,LocationRoute: LocationRouteWithChildren,MembershipRoute: MembershipRoute,OpdDoctorsRoute: OpdDoctorsRouteWithChildren,OphthalmologistRoute: OphthalmologistRoute,OrthopaedicsRoute: OrthopaedicsRoute,PathLabRoute: PathLabRoute,PatientCareRoute: PatientCareRouteWithChildren,PharmacyRoute: PharmacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProductsRoute: ProductsRoute,ReturnAndExchangeRoute: ReturnAndExchangeRoute,ReturnsExchangesRoute: ReturnsExchangesRoute,RunWithHealicRoute: RunWithHealicRoute,SearchRoute: SearchRoute,ShippingPolicyRoute: ShippingPolicyRoute,SurgeryDoctorsRoute: SurgeryDoctorsRouteWithChildren,TermsAndConditionsRoute: TermsAndConditionsRoute,UrologyRoute: UrologyRoute,CityTopicRoute: CityTopicRoute,AestheticsSlugRoute: AestheticsSlugRoute,CosmeticGynecologySlugRoute: CosmeticGynecologySlugRoute,EntSurgeriesSlugRoute: EntSurgeriesSlugRoute,GeneralSurgeriesSlugRoute: GeneralSurgeriesSlugRoute,GynecologySurgeriesSlugRoute: GynecologySurgeriesSlugRoute,LocationsAgraRoute: LocationsAgraRoute,LocationsHaridwarRoute: LocationsHaridwarRoute,LocationsIndirapuramGhaziabadRoute: LocationsIndirapuramGhaziabadRoute,LocationsMuzaffarnagarRoute: LocationsMuzaffarnagarRoute,LocationsSohnaRoadGurugramRoute: LocationsSohnaRoadGurugramRoute,OphthalmologistSurgeriesSlugRoute: OphthalmologistSurgeriesSlugRoute,OrthopaedicsSurgeriesSlugRoute: OrthopaedicsSurgeriesSlugRoute,SpecialtiesSlugRoute: SpecialtiesSlugRoute,SurgeriesSlugRoute: SurgeriesSlugRouteWithChildren,TreatmentsSlugRoute: TreatmentsSlugRoute,UrologySurgeriesSlugRoute: UrologySurgeriesSlugRoute,AestheticsIndexRoute: AestheticsIndexRoute,CosmeticGynecologyIndexRoute: CosmeticGynecologyIndexRoute,LocationsIndexRoute: LocationsIndexRoute,SpecialtiesIndexRoute: SpecialtiesIndexRoute,SurgeriesIndexRoute: SurgeriesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)